import { render, staticRenderFns } from "./ReviewsHistory.vue?vue&type=template&id=5a91ee4a"
import script from "./ReviewsHistory.vue?vue&type=script&lang=js"
export * from "./ReviewsHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports